// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import { Spinner } from '@oysterjs/ui/spinner';

/**
 * PDF iframe preview shown when the toolbar preview toggle is active.
 */
export function EditorPreviewPane(props: {
  previewUrl: string;
  previewKey: number;
  isIframeLoading: boolean;
  onIframeLoad: () => void;
}) {
  return (
    <div className="relative flex flex-col h-full overflow-hidden bg-neutral-50 dark:bg-neutral-900">
      {props.isIframeLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-neutral-50 dark:bg-neutral-800 z-10">
          <div className="flex flex-col items-center gap-3">
            <Spinner size="size-8" color="neutral" />
            <p className="text-sm text-neutral-500 dark:text-neutral-400">Loading preview...</p>
          </div>
        </div>
      )}
      <iframe
        key={props.previewKey}
        src={props.previewUrl}
        onLoad={props.onIframeLoad}
        className="w-full h-full"
        title="Document Preview"
      />
    </div>
  );
}
